module.exports = __webpack_public_path__ + "static/media/botonCinturones.d377aac0.png";